<template>
  <div class="mention-container" @click="toProjectPage">
    <a-badge :count="redPointNum" :overflow-count="99" :number-style="{ backgroundColor: '#ff4d4f', fontSize: '10px' }">
      <div class="content">
        <a-icon type="bell" />
        <span class="text">待办</span>
      </div>
    </a-badge>
  </div>
</template>

<script>
import { getDailyWorkInfo } from '@/api/project/project';
export default {
  name: 'Mention',
  data() {
    return {
      redPointNum: 0
    };
  },
  mounted() {
    this.getDiagramData();
  },
  methods: {
    getDiagramData() {
      getDailyWorkInfo({ flag: 'total' })
        .then(res => {
          this.redPointNum = res.data.total;
        })
        .catch(err => {
          console.error('Failed to load todo count:', err);
          this.redPointNum = 0;
        });
    },
    toProjectPage() {
      this.$router.push({
        path: '/projects',
        query: { category: 'mission-list' }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.mention-container {
  display: flex;
  align-items: center;
  height: 48px;
  padding: 0 4px;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.3s ease;
  color: rgba(0, 0, 0, 0.65);

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
    color: rgba(0, 0, 0, 0.85);
  }

  .content {
    display: flex;
    align-items: center;

    .anticon {
      font-size: 18px;
      margin-right: 6px;
      transition: color 0.3s ease;
    }

    .text {
      font-size: 14px;
      font-weight: 500;
      line-height: 1;
      user-select: none;
    }
  }
}
</style>
